jQuery(document).ready(function($) {

    $( ".bloc_catalogues" ).each(function( index ) {

        var parent = $(this).find(".catalogues")
        var cibleAcces = parent.find(".anim")

        // Décalage réduit sous 1024px : en colonne, 200px repoussaient les
        // tuiles loin sous leur place pendant tout le défilement.
        var decalage = window.matchMedia("(max-width: 1023.98px)").matches ? 60 : 200

        gsap.from( cibleAcces, {
            y : decalage,
            duration: 1,
            stagger: .2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 100%",
                end: "top 50%",
                scrub: 1,
            }

        })

    })

});